import { Component, ErrorInfo, ReactNode } from 'react';
import { captureException, getScopeContext } from '../../../utils/tracking/sentry/sentry';
import ErrorBox from '../ErrorBox';

type Props = { children: ReactNode };

class TurnstileErrorBoundary extends Component<Props, { hasError: boolean }> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    captureException(error, getScopeContext({ errorInfo }));
  }
  render() {
    if (this.state.hasError) {
      return (
        <ErrorBox message="Something went wrong with our captcha system. Please retry later" />
      );
    }

    return this.props.children;
  }
}

export default TurnstileErrorBoundary;
